import { Css } from "@homebound/beam";
export const ArchivedTag = ({ children, active }: { children: React.ReactNode; active: boolean }) => (
  <div css={Css.dib.$}>
    {children}
    {!active ? <span css={Css.red400.ml1.$}>(Archived)</span> : ""}
  </div>
);
